import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Star } from "lucide-react";
import SEO from "@/components/site/SEO";
import { SORTED_AREAS, COMPANY } from "@/lib/constants";

export default function ServiceAreas() {
  const primary = SORTED_AREAS.find((a) => a.primary);
  const rest = SORTED_AREAS.filter((a) => !a.primary);

  return (
    <div>
      <SEO title="Concrete Service Areas | CG Concrete LLC, WI" description="CG Concrete serves Watertown, WI and 24 nearby communities across Jefferson, Dodge, Waukesha, Columbia & Dane counties. Find your city and get a free quote." />
      <section className="bg-secondary text-white grain-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <span className="text-primary font-bold text-sm tracking-widest">WHERE WE WORK</span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-3">Service Areas</h1>
          <p className="text-white/70 mt-5 text-lg max-w-2xl">Based in {COMPANY.city}, we pour quality concrete across {SORTED_AREAS.length} communities in southeast Wisconsin. Find your town below.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Highlighted home base */}
        {primary && (
          <Link to={`/service-areas/${primary.slug}`} className="group block relative overflow-hidden bg-secondary text-white mb-8 border-2 border-primary" data-testid={`area-card-${primary.slug}`}>
            <div className="absolute inset-0 grain-texture opacity-40" />
            <div className="relative p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 bg-primary text-white text-xs font-bold px-3 py-1 tracking-wider"><Star className="h-3.5 w-3.5 fill-white" /> HOME BASE</span>
                <h2 className="font-heading text-3xl sm:text-4xl font-extrabold mt-3">{primary.city}, {primary.state}</h2>
                <p className="text-white/70 mt-2 max-w-xl">{primary.highlight}</p>
              </div>
              <span className="inline-flex items-center gap-2 font-bold text-primary shrink-0 group-hover:gap-3 transition-all">Explore {primary.city} <ArrowRight className="h-5 w-5" /></span>
            </div>
          </Link>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {rest.map((a) => (
            <Link key={a.slug} to={`/service-areas/${a.slug}`} className="group bg-card border border-border p-6 hover:border-primary hover:-translate-y-1 transition-all" data-testid={`area-card-${a.slug}`}>
              <div className="flex items-center justify-between">
                <MapPin className="h-6 w-6 text-primary" />
                <span className="text-xs text-muted-foreground font-semibold">{a.county}</span>
              </div>
              <h3 className="font-heading text-xl font-bold mt-3">{a.city}, {a.state}</h3>
              <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{a.highlight}</p>
              <span className="inline-flex items-center gap-1 text-sm font-bold text-primary mt-4 group-hover:gap-2 transition-all">View area <ArrowRight className="h-4 w-4" /></span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
